import { TableBody as MuiTableBody } from '@mui/material';

import type { TableBodyProps } from './types';

const TableBody = (props: TableBodyProps) => {
  return <MuiTableBody {...props} />;
};

export default TableBody;
